import { Header } from '@/components/Header';
import { CENTER_FULL_SERVICE_UNAVAILABLE_MESSAGE } from '@/utils/centerServiceAvailability';
import './ServiceReservationGuide.scss';

export function ServiceUnavailableGuide() {
    return (
        <div className="service-reservation-guide-page">
            <Header />

            <main className="service-reservation-guide-main">
                <div className="service-reservation-guide-card">
                    <h1>서비스 이용 안내</h1>
                    <p>{CENTER_FULL_SERVICE_UNAVAILABLE_MESSAGE}</p>
                </div>
            </main>
        </div>
    );
}
